<header class="ds-header" (mouseleave)="closeMegaMenu()">
  <div class="ds-header-container">
    <!-- Mobile Sidebar Toggle Button (Orange) -->
    <button class="ds-mobile-sidebar-toggle"
      (click)="toggleSidebarEvent.emit()">
      <span class="burger-lines">
        <span class="burger-line"></span>
        <span class="burger-line"></span>
        <span class="burger-line"></span>
      </span>
    </button>

    <!-- Mobile Menu Burger Button (Teal) -->
    <button class="ds-mobile-burger"
      (click)="toggleMobileMenu($event)"
      [class.active]="isMobileMenuOpen">
      <span class="burger-lines">
        <span class="burger-line"></span>
        <span class="burger-line"></span>
        <span class="burger-line"></span>
      </span>
    </button>

    <!-- Main Navigation -->
    <nav class="ds-header-nav">
      <ul class="ds-nav-list">
        @for (item of menuItems; track item) {
          <li
            class="ds-nav-item"
            [class.active]="isMenuItemActive(item)"
            [class.has-mega-menu]="item.megaMenu"
            (mouseenter)="item.megaMenu ? openMegaMenu(item.label) : null">
            <!-- Direct Link (no mega menu) -->
            @if (!item.megaMenu && item.routerLink) {
              <a
                [routerLink]="item.routerLink"
                class="ds-nav-link"
                routerLinkActive="active">
                @if (item.icon) {
                  <i [class]="item.icon"></i>
                }
                <span>{{ item.label }}</span>
                @if (item.badge) {
                  <span class="ds-badge">{{ item.badge }}</span>
                }
              </a>
            }
            <!-- Mega Menu Trigger -->
            @if (item.megaMenu) {
              <a
                class="ds-nav-link ds-nav-trigger"
                [class.active]="isMenuItemActive(item)"
                (click)="toggleMegaMenu(item.label, $event)">
                @if (item.icon) {
                  <i [class]="item.icon"></i>
                }
                <span>{{ item.label }}</span>
                <i class="pi pi-chevron-down ds-chevron"></i>
              </a>
            }
          </li>
        }
      </ul>

      <!-- Mega Menu Panel -->
      @if (activeMenu) {
        <div
          class="ds-mega-menu-panel"
          [@slideDown]
          (mouseleave)="closeMegaMenu()">
          <div class="ds-mega-menu-content">
            <div class="ds-mega-menu-sections">
              @for (item of menuItems; track item) {
                @if (item.label === activeMenu && item.megaMenu) {
                  @for (section of item.megaMenu; track section) {
                    <div
                      class="ds-mega-menu-section"
                      [class.featured]="section.featured">
                      <h4 class="ds-section-title">{{ section.title }}</h4>
                      <ul class="ds-section-links">
                        @for (link of section.items; track link) {
                          <li>
                            <a [routerLink]="link.routerLink"
                              class="ds-mega-link"
                              routerLinkActive="active"
                              (click)="closeMegaMenu()">
                              @if (link.icon) {
                                <i [class]="link.icon"></i>
                              }
                              <div class="ds-link-content">
                                <span class="ds-link-label">
                                  {{ link.label }}
                                  @if (link.badge) {
                                    <span class="ds-badge">{{ link.badge }}</span>
                                  }
                                </span>
                                @if (link.description) {
                                  <span class="ds-link-description">
                                    {{ link.description }}
                                  </span>
                                }
                              </div>
                            </a>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                }
              }
            </div>
          </div>
        </div>
      }
    </nav>

    <!-- Right Section -->
    <div class="ds-header-actions">
      <!-- Back to Admin Button -->
      @if (viewingRoleAsAdmin) {
        <button
          class="ds-btn-admin-switch"
          (click)="exitRoleView($event)">
          <i class="fa fa-arrow-left"></i>
          <span>{{ 'dsGalleryHeader.backToAdmin' | transloco }}</span>
        </button>
      }

      <!-- Free Trial Timer -->
      @if (isOnFreeTrial) {
        <div class="ds-free-trial-timer">
          <span class="ds-trial-text">{{ 'dsGalleryHeader.trialEndsIn' | transloco }}
            @if (remainingTime?.display) {
              <strong>{{ remainingTime.display }}</strong>
            }
          </span>
          @if (!isFreePlanUser) {
            <button class="ds-btn-upgrade" (click)="onShowUpgradeDialog()">
              {{ 'dsGalleryHeader.upgrade' | transloco }}
            </button>
          }
        </div>
      }

      <!-- Free Trial Start Button -->
      @if (isFreePlanUser && !isOnFreeTrial && !hasFreeTrialEnded) {
        <button class="ds-btn-free-trial"
          (click)="onStartFreeTrial()">
          <i class="fa fa-gift"></i>
          <span>{{ 'dsGalleryHeader.startTrial' | transloco }}</span>
        </button>
      }

      <!-- Upgrade Button -->
      @if (isFreePlanUser) {
        <div class="ds-upgrade-btn">
          <a href="javascript:void(0);" (click)="onShowUpgradeDialog()">
            <img src="assets/images/upgrade-nag-button-200h.png" height="28" [alt]="'dsGalleryHeader.upgrade' | transloco"
              onerror="this.src='assets/images/No-Image.png'" />
          </a>
        </div>
      }

      <!-- Primary CTA Button - Gallery: Add Artist -->
      <button class="ds-btn-primary"
        routerLink="/galleries/gallery-product/create">
        <i class="pi pi-plus"></i>
        <span>{{ 'dsGalleryHeader.create' | transloco }}</span>
      </button>

      <!-- Messages Icon -->
      @if (isChatBoxMessagesShow) {
        <div class="ds-notification-icon">
          <button (click)="onToggleMessages($event)" class="ds-icon-btn">
            <i class="fa fa-comments"></i>
            @if (countUnreadchatbox) {
              <span class="ds-badge">{{ countUnreadchatbox }}</span>
            }
          </button>
          @if (showMessages) {
            <div class="ds-notification-dropdown">
              @if (isLoadingMessages) {
                <div class="ds-loading">
                  <i class="fa fa-spinner fa-spin"></i>
                </div>
              }
              @for (message of chatmessages.slice(0, 5); track message) {
                <div class="ds-notification-item" (click)="onChatWithUser(message)">
                  <img [src]="message.SenderImgUrl || 'assets/images/No-Image.png'"
                    (error)="$any($event.target).src='assets/images/No-Image.png'"
                    class="ds-notification-avatar" />
                  <div class="ds-notification-content">
                    <div class="ds-notification-header">
                      <span class="ds-notification-name">{{ message.SenderUserName }}</span>
                      @if (message.UnreadCount) {
                        <span class="ds-unread-badge">{{ message.UnreadCount }}</span>
                      }
                    </div>
                    <p class="ds-notification-body">{{ message.LastMessageBody | slice:0:60 }}...</p>
                  </div>
                </div>
              }
              @if (chatmessages.length > 4) {
                <div class="ds-notification-footer">
                  <a (click)="onNavigateToMessagesList()">{{ 'dsGalleryHeader.seeAllMessages' | transloco }}</a>
                </div>
              }
              @if (chatmessages.length === 0 && !isLoadingMessages) {
                <div class="ds-notification-empty">
                  {{ 'dsGalleryHeader.noMessages' | transloco }}
                </div>
              }
            </div>
          }
        </div>
      }

      <!-- Notifications Icon -->
      <div class="ds-notification-icon">
        <button (click)="onToggleNotifications($event)" class="ds-icon-btn">
          <i class="fa fa-bell"></i>
          @if (countUnreadNotificaion) {
            <span class="ds-badge">{{ countUnreadNotificaion }}</span>
          }
        </button>
        @if (showNotifications) {
          <div class="ds-notification-dropdown">
            @if (isLoadingNotifications) {
              <div class="ds-loading">
                <i class="fa fa-spinner fa-spin"></i>
              </div>
            }
            @for (notification of notifications.slice(0, 5); track notification) {
              <div class="ds-notification-item" (click)="onHandleNotificationClick(notification)">
                <i class="fa fa-bell ds-notification-icon-small" [class.text-success]="notification.IsRead" [class.text-danger]="!notification.IsRead"></i>
                <div class="ds-notification-content">
                  <div class="ds-notification-header">
                    <span class="ds-notification-name">{{ notification.Title }}</span>
                  </div>
                  <p class="ds-notification-body">{{ notification.Body | slice:0:60 }}...</p>
                </div>
              </div>
            }
            @if (notifications.length > 5) {
              <div class="ds-notification-footer">
                <a (click)="onNavigateToNotificationsList()">{{ 'dsGalleryHeader.seeAllNotifications' | transloco }}</a>
              </div>
            }
            @if (notifications.length === 0 && !isLoadingNotifications) {
              <div class="ds-notification-empty">
                {{ 'dsGalleryHeader.noNotifications' | transloco }}
              </div>
            }
          </div>
        }
      </div>

      <!-- Language Switcher -->
      <app-language-switcher class="ds-lang-switcher me-2"></app-language-switcher>

      <!-- User Avatar Dropdown -->
      @if (authUser) {
        <div class="ds-user-menu">
          <button class="ds-user-avatar"
            (click)="toggleUserMenu($event)"
            [class.active]="isUserMenuOpen">
            <img [src]="authUser.PersonalImgUrl || authUser.LogoUrl || 'assets/images/default-avatar.png'"
              (error)="$any($event.target).src='assets/images/No-Image.png'"
              [alt]="userFullName"
              height="40" />
          </button>
          @if (isUserMenuOpen) {
            <div class="ds-user-dropdown" (click)="$event.stopPropagation()">
              <div class="ds-user-info">
                <div class="ds-user-avatar-large">
                  <img [src]="authUser.PersonalImgUrl || authUser.LogoUrl || 'assets/images/default-avatar.png'"
                    (error)="$any($event.target).src='assets/images/No-Image.png'"
                    [alt]="userFullName" />
                </div>
                <div class="ds-user-details">
                  <span class="ds-user-name">{{ userFullName }}</span>
                  <span class="ds-user-email">{{ authUser.EmailAddress }}</span>
                </div>
              </div>
              @if (planDisplayText && !authConfig?.IsJudge && !authConfig?.IsCurator) {
                <div class="ds-plan-badge">
                  <span class="ds-plan-label">{{ 'dsGalleryHeader.yourPlan' | transloco }}</span>
                  <span class="ds-plan-value" [class.pro]="!isFreePlanUser">{{ planDisplayText }}</span>
                </div>
              }
              <div class="ds-dropdown-divider"></div>
              <nav class="ds-user-nav">
                <a class="ds-user-nav-item" routerLink="/edit-profile" (click)="closeUserMenu()">
                  <i class="pi pi-user"></i>
                  <span>{{ 'dsGalleryHeader.myProfile' | transloco }}</span>
                </a>
                @if (showSubscriptionsLink) {
                  <a class="ds-user-nav-item"
                    routerLink="/user-invoice" (click)="closeUserMenu()">
                    <i class="pi pi-credit-card"></i>
                    <span>{{ 'dsGalleryHeader.mySubscriptions' | transloco }}</span>
                  </a>
                }
                <!-- TEMPORARY: nav-migration "all pages" directory. Remove with the new nav. -->
                <a class="ds-user-nav-item" routerLink="/all-pages" (click)="closeUserMenu()">
                  <i class="pi pi-list"></i>
                  <span>All pages</span>
                </a>
              </nav>
              <div class="ds-dropdown-divider"></div>
              <div class="ds-user-actions">
                <a class="ds-user-nav-item ds-sign-out" href="#" (click)="logout($event)">
                  <i class="pi pi-sign-out"></i>
                  <span>{{ 'dsGalleryHeader.signOut' | transloco }}</span>
                </a>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Overlay for closing mega menu -->
  @if (activeMenu) {
    <div
      class="ds-mega-menu-overlay"
    (click)="closeMegaMenu()"></div>
  }

  <!-- Overlay for closing user menu -->
  @if (isUserMenuOpen) {
    <div
      class="ds-user-menu-overlay"
    (click)="closeUserMenu()"></div>
  }

  <!-- Mobile Menu Panel -->
  <div class="ds-mobile-menu" [class.open]="isMobileMenuOpen">
    <div class="ds-mobile-menu-header">
      <span class="ds-mobile-menu-title">{{ 'dsGalleryHeader.menu' | transloco }}</span>
      <button class="ds-mobile-close" (click)="closeMobileMenu()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <nav class="ds-mobile-nav">
      <ul class="ds-mobile-nav-list">
        @for (item of menuItems; track item) {
          <li class="ds-mobile-nav-item">
            <!-- Direct Link -->
            @if (!item.megaMenu && item.routerLink) {
              <a
                [routerLink]="item.routerLink"
                class="ds-mobile-nav-link"
                routerLinkActive="active"
                (click)="closeMobileMenu()">
                @if (item.icon) {
                  <i [class]="item.icon"></i>
                }
                <span>{{ item.label }}</span>
                @if (item.badge) {
                  <span class="ds-badge">{{ item.badge }}</span>
                }
              </a>
            }
            <!-- Expandable Menu Item -->
            @if (item.megaMenu) {
              <div class="ds-mobile-expandable">
                <button class="ds-mobile-nav-link ds-mobile-expand-trigger"
                  (click)="toggleMobileSubMenu(item.label)"
                  [class.expanded]="expandedMobileMenu === item.label">
                  @if (item.icon) {
                    <i [class]="item.icon"></i>
                  }
                  <span>{{ item.label }}</span>
                  <i class="pi pi-chevron-down ds-mobile-chevron"></i>
                </button>
                @if (expandedMobileMenu === item.label) {
                  <div class="ds-mobile-submenu">
                    @for (section of item.megaMenu; track section) {
                      <div class="ds-mobile-section">
                        <span class="ds-mobile-section-title">{{ section.title }}</span>
                        <ul class="ds-mobile-section-links">
                          @for (link of section.items; track link) {
                            <li>
                              <a [routerLink]="link.routerLink"
                                class="ds-mobile-sublink"
                                routerLinkActive="active"
                                (click)="closeMobileMenu()">
                                @if (link.icon) {
                                  <i [class]="link.icon"></i>
                                }
                                <span>{{ link.label }}</span>
                              </a>
                            </li>
                          }
                        </ul>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </li>
        }
      </ul>
    </nav>

    <!-- Mobile Quick Actions -->
    <div class="ds-mobile-actions">
      <button class="ds-mobile-btn-primary"
        routerLink="/galleries/gallery-product/create"
        (click)="closeMobileMenu()">
        <i class="pi pi-plus"></i>
        <span>{{ 'dsGalleryHeader.createGalleryProduct' | transloco }}</span>
      </button>
    </div>
  </div>

  <!-- Mobile Menu Overlay -->
  @if (isMobileMenuOpen) {
    <div
      class="ds-mobile-menu-overlay"
    (click)="closeMobileMenu()"></div>
  }
</header>
